import type { PaymentRowDto } from '../api/paymentsApi';

/**
 * Aggregates payment rows by worker identity (personName + accountNumber + sortCode).
 * When a worker appears in multiple pots, their amounts are summed into a single row.
 * The potReference field joins all contributing pot references with ", ".
 *
 * TODO: The backend should return a stable `workerId` to replace this composite key.
 */
export function aggregatePaymentsByWorker(
  payments: PaymentRowDto[]
): PaymentRowDto[] {
  const byWorker = new Map<string, PaymentRowDto[]>();

  for (const p of payments) {
    const key = `${p.personName}|${p.accountNumber ?? ''}|${p.sortCode ?? ''}`;
    const existing = byWorker.get(key);
    if (existing) existing.push(p);
    else byWorker.set(key, [p]);
  }

  return [...byWorker.values()].map(rows => ({
    personName: rows[0].personName,
    potReference: rows.map(r => r.potReference).join(', '),
    accountNumber: rows[0].accountNumber,
    sortCode: rows[0].sortCode,
    companyName: rows[0].companyName,
    amountDue: rows.reduce((sum, r) => sum + r.amountDue, 0),
    potStatus: rows.every(r => r.potStatus === 'Paid')
      ? 'Paid'
      : rows.some(r => r.potStatus === 'Paid')
        ? 'Partially Paid'
        : 'Approved',
  }));
}
